const stretchLiveApiEndpoints = {
	EVENT_BY_MEDIA: (id, mediaType) => `/events/${id}/media-formats/${mediaType}`
};

export default stretchLiveApiEndpoints;
